import styled from 'styled-components';
import UsStatesSelect from '@carvana/showroom-forms/Select/UsStatesSelect';
import { Input } from '@carvana/showroom-forms';

export const EditAddressFormWrapper = styled.form`
  display: flex;
  flex-flow: column;
`;

export const CityFormInput = styled(Input)`
  width: 240px;
`;

export const UsStatesSelectWrapper: typeof UsStatesSelect = styled(UsStatesSelect)`
  background: var(--cvna-color-grey-1);

  span {
    font-weight: bold !important;
  }
`;
